// ABJ demo clone of src/components/washUFluoroscopy/injection_support-4.js (4.0 Preparing for Success, listed under Planning 3.0).
// Copied verbatim 10/14/26 — copy and header colors pending from Jeff. Route: /abj-demo-injection-4
import React from "react";
import Container from "react-bootstrap/Container";
import { Nav } from "react-bootstrap";
import "@fortawesome/fontawesome-svg-core/styles.css";
import { HashLink as Link } from "react-router-hash-link";

const InjectionSupport4 = () => {
  return (
    <div>
      <div className="w-100">
        <Container>
          <div className="w-100">
            <div className="col-10 m-auto">
              <div className="whiteBackground floatLeft clearLeft legosNewBuild">
                <section>
                  {/* L1 Tile Title Header */}
                  <div className="lego l001 abjHeadereb6d7d legoMargin5">
                    <h1 className="tileTitle">Your Team</h1>
                    <hr className="w-100 l001Rule" />
                  </div>
                  {/* End Tile Title Header L1 */}

                  {/* L12 Head, Lead In Photo Small with body copy */}
                  <div className="lego l012 legoMargin3">
                    {/* L3 Subhead Upper and Lower */}
                    <div className="lego l003">
                      <h2 className="subHeadUpperAndLowerCase">
                        Working with your team.{" "}
                      </h2>
                    </div>
                    {/* End L3 Subhead Upper and Lower */}
                    <div className="contentContainer">
                      <div className="imgContainer">
                        <img
                          className=""
                          alt="Image of doctors smiling"
                          src="https://orbit-image-video-bucket.s3.us-east-2.amazonaws.com/20a4be810f762845fc68010524845879.png"
                        />
                      </div>
                      <div className="copyContainer">
                        {/* L14 Paragraph */}
                        <div className="lego l00paragraph legoMargin3">
                          <p>
                            Your care team is here to provide world-class health
                            care in a compassionate, respectful and responsive
                            way. We are committed to help you during this
                            journey.
                          </p>
                          <p>
                            Teams are made up of a variety of professionals who
                            work in combination toward your healthy outcomes.
                          </p>
                        </div>
                        {/* End L14 Paragraph */}
                      </div>
                    </div>
                  </div>
                  {/* End L12 Head, Lead In Photo Small with body copy */}

                  {/* L10A Bold Lead In */}
                  <div className="lego l00paragraph">
                    <p>
                      {" "}
                      <span className="boldLeadInNewUI">
                        Registered Nurse (RN) and Patient Care Tech (PCT)
                      </span>
                    </p>
                  </div>
                  {/* End L10A Bold Lead In */}

                  {/* L14 Paragraph */}
                  <div className="lego l00paragraph legoMargin2">
                    <p>
                      Your care team is trained in orthopedics and will follow
                      your surgeon’s plan for your rapid recovery. They will
                      teach you and your joint coach how to stay safe and
                      healthy during every step of your recovery.
                    </p>
                  </div>
                  {/* End L14 Paragraph */}

                  {/* L10A Bold Lead In */}
                  <div className="lego l00paragraph">
                    <p>
                      {" "}
                      <span className="boldLeadInNewUI">
                        Physical Medicine and Rehabilitation (Physiatry) Team
                      </span>{" "}
                    </p>
                  </div>
                  {/* End L10A Bold Lead In */}

                  {/* L14 Paragraph */}
                  <div className="lego l00paragraph legoMargin2">
                    <p>
                      Your physiatrist (also known as a physical medicine and
                      rehabilitation specialist) uses nonsurgical approaches to
                      pain and injury treatment with a focus on the whole person
                      and their physical, psychological, social, and vocational
                      potential.
                    </p>
                  </div>
                  {/* End L14 Paragraph */}

                  {/* L10A Bold Lead In */}
                  <div className="lego l00paragraph">
                    <p>
                      {" "}
                      <span className="boldLeadInNewUI">Anesthesia Team</span>
                    </p>
                  </div>
                  {/* End L10A Bold Lead In */}

                  {/* L14 Paragraph */}
                  <div className="lego l00paragraph legoMargin2">
                    <p>
                      An anesthesia physician or advanced practice nurse will
                      evaluate your surgery needs. This team is specially
                      trained to keep you safe during surgery and in recovery.
                      They are key team members to manage your pain. You will
                      meet a member of this team at your surgical evaluation with our team.
                    </p>
                  </div>
                  {/* End L14 Paragraph */}

                  {/* L10A Bold Lead In */}
                  <div className="lego l00paragraph">
                    <p>
                      {" "}
                      <span className="boldLeadInNewUI">
                        Physical Therapist (PT)
                      </span>{" "}
                    </p>
                  </div>
                  {/* End L10A Bold Lead In */}

                  {/* L14 Paragraph */}
                  <div className="lego l00paragraph legoMargin2">
                    <p>
                      Your physical therapy team plans the best way for you to
                      build your strength before and after receiving your new
                      joint. This team utilizes special training to help get you
                      moving and boost your abilities with your new joint.
                    </p>
                  </div>
                  {/* End L14 Paragraph */}

                  {/* L10A Bold Lead In */}
                  <div className="lego l00paragraph">
                    <p>
                      {" "}
                      <span className="boldLeadInNewUI">
                        Nurse Practitioner (NP)
                      </span>{" "}
                    </p>
                  </div>
                  {/* End L10A Bold Lead In */}

                  {/* L14 Paragraph */}
                  <div className="lego l00paragraph legoMargin2">
                    <p>
                      Your advanced practice registered nurse will work with
                      your surgeon to manage your care. Your nurse practitioner
                      will see you on the floor after your surgery.
                    </p>
                  </div>
                  {/* End L14 Paragraph */}

                  {/* L10A Bold Lead In */}
                  <div className="lego l00paragraph">
                    <p>
                      {" "}
                      <span className="boldLeadInNewUI">
                        Occupational Therapist (OT)
                      </span>{" "}
                    </p>
                  </div>
                  {/* End L10A Bold Lead In */}

                  {/* L14 Paragraph */}
                  <div className="lego l00paragraph legoMargin2">
                    <p>
                      Your occupational therapist will help you plan to safely
                      complete daily activities, like dressing and bathing. They
                      will teach you how to be independent at home.
                    </p>
                  </div>
                  {/* End L14 Paragraph */}

                  {/* L10A Bold Lead In */}
                  <div className="lego l00paragraph">
                    <p>
                      {" "}
                      <span className="boldLeadInNewUI">Case Manager</span>{" "}
                    </p>
                  </div>
                  {/* End L10A Bold Lead In */}

                  {/* L14 Paragraph */}
                  <div className="lego l00paragraph legoMargin2">
                    <p>
                      Your case manager is trained as a registered nurse or
                      social worker. Your case manager will plan with your care
                      team to best assist your needs regarding discharge, home
                      equipment and help you with your insurance questions.
                    </p>
                  </div>
                  {/* End L14 Paragraph */}

                  {/* L10A Bold Lead In */}
                  <div className="lego l00paragraph">
                    <p>
                      {" "}
                      <span className="boldLeadInNewUI">
                        Orthopedic Concierge (available at our office)
                      </span>{" "}
                    </p>
                  </div>
                  {/* End L10A Bold Lead In */}

                  {/* L14 Paragraph */}
                  <div className="lego l00paragraph legoMargin5">
                    <p>
                      The orthopedic concierge will help with any lodging needs
                      for your loved ones during or after your stay. They will
                      visit you and your family during your stay and explain
                      services offered, such as computer use, notaries,
                      restaurant suggestions, attractions, transportation and
                      explaining the medical campus. The concierge focuses on
                      providing an exceptional experience for you and your loved
                      ones while you are at the hospital.
                    </p>
                  </div>
                  {/* End L14 Paragraph */}

                  <div className="col-12 backToTop">
                    <div className="w-100">
                      <p>
                        <a
                          className="specialUseBackToTop"
                          onClick={() =>
                            window.scrollTo({ top: 0, behavior: "smooth" })
                          }
                        >
                          BACK TO TOP{" "}
                        </a>
                      </p>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default InjectionSupport4;
